import React from "react";
import { Box, Button, Stack, TextField } from "@curves/ui-base";
import { Grid } from "@mui/material";
import { FieldRow } from "@icoach/documents/components/Layout";
import ChangeFeeRecordsContent from "@icoach/documents/membership/quit/components/ChangeFeeRecordsContent";
import { formatCurrencyFn, getErrorModuleStatus } from "@util/utils";
import { useMembershipQuitFormContext } from "@icoach/documents/membership/quit/MembershipQuitFormContext";

const MembershipQuitRangeFeeSection104 = ({ sourceData }) => {
	const { formData, formRef, validationErrors, updateField, dialogRef, manualTriggerRangeFee, isReadOnly } = useMembershipQuitFormContext();

	return (
		<Grid item xs={6}>
			<Grid container spacing={3}>
				<FieldRow items={[4, 8]} label="當月已收月費" required>
					<TextField
						ref={el => (formRef.current.lastMonthlyFee = el)}
						key={formData?.lastMonthlyFee}
						defaultValue={formData?.lastMonthlyFee}
						onChangeNative={e => updateField("lastMonthlyFee", e.target.value)}
						{...getErrorModuleStatus(validationErrors, "lastMonthlyFee")}
						maskType="MONEY"
						readOnly={isReadOnly}
						fullWidth
						required
					/>
				</FieldRow>
				<FieldRow items={[4, 8]} label="破月日" required>
					<TextField
						ref={el => (formRef.current.firstMonthDay = el)}
						key={formData?.firstMonthDay}
						defaultValue={formData?.firstMonthDay}
						onChangeNative={e => updateField("firstMonthDay", e.target.value)}
						{...getErrorModuleStatus(validationErrors, "firstMonthDay")}
						maskType="MONEY"
						readOnly={isReadOnly}
						fullWidth
						required
					/>
				</FieldRow>
				<FieldRow items={[4, 8]} label="會員權暫停" required>
					<Stack direction="row" spacing="2">
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.suspendMonth = el)}
								key={formData?.suspendMonth}
								defaultValue={formData?.suspendMonth}
								onChangeNative={e => updateField("suspendMonth", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "suspendMonth")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								fullWidth
								required
							/>
							<span>月</span>
						</Stack>
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.suspendDay = el)}
								key={formData?.suspendDay}
								defaultValue={formData?.suspendDay}
								onChangeNative={e => updateField("suspendDay", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "suspendDay")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								fullWidth
								required
							/>
							<span>天</span>
						</Stack>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]}>
					<Button
						variant="outlined"
						color="secondary"
						className="btn-minWidth"
						fullWidth
						onClick={() =>
							dialogRef?.current?.openSuspendReasonsDialog?.({
								memberID: formData?.memberID,
								membershipID: formData?.membershipID,
							})
						}
					>
						查看暫停紀錄
					</Button>
				</FieldRow>
				<FieldRow items={[4, 8]} label="贈送" required>
					<Stack direction="row" spacing="2">
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.giftMonth = el)}
								key={formData?.giftMonth}
								defaultValue={formData?.giftMonth}
								onChangeNative={e => updateField("giftMonth", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "giftMonth")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								fullWidth
								required
							/>
							<span>月</span>
						</Stack>
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.giftDay = el)}
								key={formData?.giftDay}
								defaultValue={formData?.giftDay}
								onChangeNative={e => updateField("giftDay", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "giftDay")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								fullWidth
							/>
							<span>天</span>
						</Stack>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]}>
					<Button
						variant="outlined"
						color="secondary"
						className="btn-minWidth"
						fullWidth
						onClick={() =>
							dialogRef?.current?.openGiftReasonsDialog?.({
								memberID: formData?.memberID,
								membershipID: formData?.membershipID,
							})
						}
					>
						查看贈送紀錄
					</Button>
				</FieldRow>
				<FieldRow items={[4, 8]} label="延展" required>
					<Stack direction="row" spacing="2">
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.unusedExtensionMonth = el)}
								key={formData?.unusedExtensionMonth}
								defaultValue={formData?.unusedExtensionMonth}
								onChangeNative={e => updateField("unusedExtensionMonth", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "unusedExtensionMonth")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								fullWidth
								required
							/>
							<span>月</span>
						</Stack>
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.unusedExtensionDay = el)}
								key={formData?.unusedExtensionDay}
								defaultValue={formData?.unusedExtensionDay}
								onChangeNative={e => updateField("unusedExtensionDay", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "unusedExtensionDay")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								readOnly={isReadOnly}
								fullWidth
								required
							/>
							<span>天</span>
						</Stack>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]}>
					<Button
						variant="outlined"
						color="secondary"
						className="btn-minWidth"
						fullWidth
						onClick={() =>
							dialogRef?.current?.openExtensionReasonsDialog?.({
								memberID: formData?.memberID,
								membershipID: formData?.membershipID,
							})
						}
					>
						查看延展紀錄
					</Button>
				</FieldRow>
				<FieldRow items={[4, 8]} label="店休">
					<Stack direction="row" spacing="2">
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.clubBreakMonth = el)}
								key={formData?.clubBreakMonth}
								defaultValue={formData?.clubBreakMonth}
								onChangeNative={e => updateField("clubBreakMonth", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "clubBreakMonth")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								fullWidth
								disabled
							/>
							<span>月</span>
						</Stack>
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.clubBreakDay = el)}
								key={formData?.clubBreakDay}
								defaultValue={formData?.clubBreakDay}
								onChangeNative={e => updateField("clubBreakDay", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "clubBreakDay")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								fullWidth
								disabled
							/>
							<span>天</span>
						</Stack>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]} label="合約總共" required>
					<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
						<TextField
							ref={el => (formRef.current.contractMonthTerm = el)}
							key={formData?.contractMonthTerm}
							defaultValue={formData?.contractMonthTerm}
							onChangeNative={e => updateField("contractMonthTerm", e.target.value)}
							{...getErrorModuleStatus(validationErrors, "contractMonthTerm")}
							maskType="MONEY"
							inputProps={{ min: 0 }}
							readOnly={isReadOnly}
							fullWidth
							required
						/>
						<span>月</span>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]} label="契約總共">
					<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
						<TextField
							ref={el => (formRef.current.totalMonth = el)}
							key={formData?.totalMonth}
							defaultValue={formData?.totalMonth}
							onChangeNative={e => updateField("totalMonth", e.target.value)}
							{...getErrorModuleStatus(validationErrors, "totalMonth")}
							maskType="MONEY"
							inputProps={{ min: 0 }}
							disabled
							fullWidth
						/>
						<span>月</span>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]}>
					<Box className="fee-tip">
						合約月數 <span className="text-info">{formData?.contractMonthTerm}</span> + 贈送月數 <span className="text-info">{formData?.giftTotalMonth}</span> + 合約始期破月數{" "}
						<span className="text-info">{formData?.firstTotalMonth}</span>
					</Box>
				</FieldRow>
				<FieldRow items={[4, 8]} label="月平均金額">
					<TextField
						ref={el => (formRef.current.avgMonthFee = el)}
						key={formData?.avgMonthFee}
						defaultValue={formData?.avgMonthFee}
						onChangeNative={e => updateField("avgMonthFee", e.target.value)}
						{...getErrorModuleStatus(validationErrors, "avgMonthFee")}
						maskType="MONEY"
						fullWidth
						disabled
					/>
				</FieldRow>
				<FieldRow items={[4, 8]}>
					<Box className="fee-tip">
						(<ChangeFeeRecordsContent sourceData={sourceData} /> + 破月費金額 <span className="text-info">{formatCurrencyFn(formData?.firstMonthFee, { symbol: "$" })}</span>
						{") "}/ 契約月數 <span className="text-info">{formData?.totalMonth}</span>
					</Box>
				</FieldRow>
				<FieldRow items={[4, 8]} label="已使用">
					<Stack direction="row" spacing="2">
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.usedMonth = el)}
								key={formData?.usedMonth}
								defaultValue={formData?.usedMonth}
								onChangeNative={e => updateField("usedMonth", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "usedMonth")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								fullWidth
								disabled
							/>
							<span>月</span>
						</Stack>
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.usedDay = el)}
								key={formData?.usedDay}
								defaultValue={formData?.usedDay}
								onChangeNative={e => updateField("usedDay", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "usedDay")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								fullWidth
								disabled
							/>
							<span>天</span>
						</Stack>
					</Stack>
				</FieldRow>
				<FieldRow items={[4, 8]} label="未履約">
					<Stack direction="row" spacing="2">
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.unusedMonth = el)}
								key={formData?.unusedMonth}
								defaultValue={formData?.unusedMonth}
								onChangeNative={e => updateField("unusedMonth", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "unusedMonth")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								fullWidth
								disabled
							/>
							<span>月</span>
						</Stack>
						<Stack direction="row" spacing="2" alignItems="center" className="leaveTextField-wrap">
							<TextField
								ref={el => (formRef.current.unusedDay = el)}
								key={formData?.unusedDay}
								defaultValue={formData?.unusedDay}
								onChangeNative={e => updateField("unusedDay", e.target.value)}
								{...getErrorModuleStatus(validationErrors, "unusedDay")}
								maskType="MONEY"
								inputProps={{ min: 0 }}
								fullWidth
								disabled
							/>
							<span>天</span>
						</Stack>
					</Stack>
				</FieldRow>
				{!isReadOnly && (
					<FieldRow items={[4, 8]}>
						<Button variant="contained" color="secondary" className="btn-minWidth" onClick={manualTriggerRangeFee} readOnly={isReadOnly} fullWidth>
							計算
						</Button>
					</FieldRow>
				)}
			</Grid>
		</Grid>
	);
};

export default MembershipQuitRangeFeeSection104;
